package com.gsb.vyapar.bhagya.datasource.network.response

import com.gsb.vyapar.bhagya.domain.Location
import kotlinx.serialization.Serializable

@Serializable
data class NominatimResponse(
    val lat: String?,
    val lon: String?,
    val address: Address?,
    val display_name: String?
) {
    @Serializable
    data class Address(
        val county: String?,
        val neighbourhood: String?,
        val postcode: String?,
        val road: String?,
        val state: String?,
        val state_district: String?,
        val suburb: String?,
        val city: String?,
        val town: String?,
        val village: String?,
    )
}

fun NominatimResponse.toLocation(): Location {
    return Location(
        address = this.address?.road + ", " + this.address?.neighbourhood + ", " + this.address?.suburb + ", " + this.address?.county,
        city = this.address?.city?: this.address?.town ?: this.address?.village ?: this.address?.state_district ?: this.address?.county ?: this.address?.suburb,
        district = this.address?.state_district,
        state = this.address?.state,
        latitude = this.lat?.toDoubleOrNull(),
        longitude = this.lon?.toDoubleOrNull(),
        pincode = this.address?.postcode
    )
}